import { TextField } from "@shopify/polaris";
import React from "react";

const CustomRedirectField = ({ input, meta }) => {
  const { touched, error, submitFailed } = meta;
  const showError = (touched || submitFailed) && error;
  return (
    <div style={{ paddingLeft: "1.75rem" }}>
      <TextField
        label="Custom URL for redirection"
        value={input.value}
        onChange={input.onChange}
        autoComplete="off"
        placeholder="https://example.com"
        error={showError}
        onBlur={() => input.onBlur()}
      />
    </div>
  );
};

export default CustomRedirectField;